<div class="c-tournament">
  <div
    class="e-tournament__background"
    theming
    themingGroup="tournament"
    themingAsset="background"
    [themingOverride]="event?.assets">
    <slotcom-navigation-button
      type="info"
      (click)="openInfo()">
    </slotcom-navigation-button>

    <slotcom-navigation-button
      type="close"
      (click)="closeModal()">
    </slotcom-navigation-button>

    <div
      class="e-tournament__logo"
      theming
      themingGroup="tournament"
      themingAsset="logo"
      [themingOverride]="event?.assets"></div>

    <div class="e-tournament__container">
      <span class="title">{{ 'home.live-ops.tournaments.modal-start.title' | translate }}</span>

      <div class="box">
        @if (!gameId) {
          <div
            class="box-icon"
            theming
            themingGroup="tournament"
            themingAsset="generic-icon"
            [themingOverride]="event?.assets"></div>
          <span class="box-text">{{ 'home.live-ops.tournaments.modal-start.generic-text' | translate }}</span>
        } @else {
          <div
            class="box-icon gameIcon"
            [ngStyle]="gameIcon"
            avoidMulticlick
            (safeClick)="handleButtonClick()"></div>
          <span class="box-text">{{
            'home.live-ops.tournaments.modal-start.specific-text' | translate: { x: gameName }
          }}</span>
        }
      </div>

      <span class="sub-title">{{ 'home.live-ops.tournaments.modal-start.subtitle' | translate }}</span>

      <div class="e-rewards">
        @for (prize of event.liveOpsStatus.maxPrize | keyvalue; track prize) {
          @if (prize.value) {
            <slotcom-reward-box
              boxThemingGroup="tournament"
              iconThemingGroup="none"
              boxAsset="reward-inactive"
              [iconAsset]="prize.key | lowercase"
              [themingOverride]="event?.assets"
              [numberValue]="prize.value">
            </slotcom-reward-box>
          }
        }
      </div>
    </div>

    <div class="e-timer">
      <span class="text">{{ 'home.live-ops.global.time-left' | translate }}</span>

      <slotcom-animated-timer
        [showInDays]="true"
        [endDate]="event.endDate"
        (expired)="closeModal()"></slotcom-animated-timer>
    </div>

    <slotcom-button
      class="c-button--pink"
      audioType="functionality"
      (safeClick)="handleButtonClick()">
      {{ 'home.live-ops.tournaments.button' | translate | uppercase }}
    </slotcom-button>
  </div>
</div>
